export default [
  {
    path: "/activity/guardhunter",
    name: "guardhunter",
    meta: {
      title: "守卫猎头",
      requireAuth: false
    },
    component: () => import("./guard/guard20200217.vue")
  },
  {
    path: "/activity/guardhh",
    name: "guardhh",
    meta: {
      title: "守卫猎头",
      requireAuth: false
    },
    component: () => import("./guard/guardpc.vue")
  },
  {
    path: "/activity/guard/select",
    name: "guardselect",
    meta: {
      title: "猎头寻求工作/挂靠",
      requireAuth: false
    },
    component: () => import("./guard/select.vue")
  },
  {
    path: "/activity/guard/rhc",
    name: "guardrhc",
    meta: {
      title: "猎头寻求猎企挂靠",
      requireAuth: false
    },
    component: () => import("./guard/rhc.vue")
  },
  {
    path: "/activity/guard/rhh",
    name: "guardrhh",
    meta: {
      title: "猎头寻求工作申请",
      requireAuth: false
    },
    component: () => import("./guard/rhh.vue")
  },
  {
    path: "/activity/guard/business",
    name: "guardrbus",
    meta: {
      title: "猎企业务合作申请",
      requireAuth: false
    },
    component: () => import("./guard/rbus.vue")
  },
  {
    path: "/activity/guard/success",
    name: "guardsuccess",
    meta: {
      title: "提交申请成功",
      requireAuth: false
    },
    component: () => import("./guard/success.vue")
  },
  {
    path: "/activity/projectTape",
    name: "projectTape",
    meta: {
      requireAuth: false
    },
    component: () => import("./projectTape/index.vue")
  }
];
